import {gql} from "@apollo/client";

export default gql`
  mutation noShowPosition($data: NoShowPositionInput!) {
    noShowPosition(data: $data)
  }
`;
